import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latest = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              最新影评
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              深度电影解读，发现影片背后的故事
            </p>
          </div>
          <Link
            to="/category/dongzuo"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              category={article.category}
              author={article.author}
              date={article.date}
              summary={article.summary}
              coverImage={article.coverImage}
              tags={article.tags}
              readTime={article.readTime}
            />
          ))}
        </div>
      </div>
    </section>
  );
}